export const environment = {
  production: true,
  env: 'Development',
  //ApiUrl: 'http://localhost:56666',
  ApiUrl: 'https://clapmapidev.clavisco.com',
  ReportKey: 51,
  recatpchaSiteKey: '6Lcx_hYqAAAAANaxShnxzAzGkkraaNVuHtbCzhb3'
};

